import { render, staticRenderFns } from "./arrow-down-header.vue?vue&type=template&id=28903cd1&"
import script from "./arrow-down-header.vue?vue&type=script&lang=js&"
export * from "./arrow-down-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports